// extracted by mini-css-extract-plugin
export default {"title":"MemberBioContainer-title-c9cb5a481682ed3d605c1f0bf86fcb19","contents":"MemberBioContainer-contents-98c26993f09b792f8485eccbd04ede60"};